/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ExceptionResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';
import { Pageable } from '../model/models';
import { PagedModelPraticaEsercenteSummaryDTO } from '../model/models';
import { PraticaEsercenteDetailDTO } from '../model/models';
import { PraticaEsercenteSelfListFilter } from '../model/models';
import { PraticaEsercenteSubmitForm } from '../model/models';
import { PraticaEsercenteSubmitResponseDTO } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface CaricaConvenzioneFirmataEsercenteRequestParams {
    idPratica: string;
    convenzione: Blob;
}

export interface DownloadAllegatoPraticaEsercenteRequestParams {
    idPratica: string;
    idAllegato: string;
}

export interface DownloadConvenzioneBandoEsercenteRequestParams {
    idPratica: string;
}

export interface DownloadConvenzioneControfirmataEsercenteRequestParams {
    idPratica: string;
}

export interface DownloadConvenzioneDaFirmareEsercenteRequestParams {
    idPratica: string;
}

export interface DownloadConvenzioneFirmataEsercenteRequestParams {
    idPratica: string;
}

export interface DownloadPdfOriginalePraticaEsercenteRequestParams {
    idPratica: string;
}

export interface GetPraticaEsercenteRequestParams {
    idPratica: string;
}

export interface ListPraticheEsercenteRequestParams {
    filter: PraticaEsercenteSelfListFilter;
    pageable: Pageable;
}

export interface RitiraPraticaEsercenteRequestParams {
    idPratica: string;
}

export interface SubmitPraticaEsercenteRequestParams {
    allParts: { [key: string]: Blob; };
    pratica: PraticaEsercenteSubmitForm;
}


export interface EsercenteDomandeServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Carica la convenzione firmata.
     * ACCETTATA_IN_ATTESA_CONVENZIONE o ACCETTATA_CONVENZIONE_RIFIUTATA → ACCETTATA_IN_ATTESA_VALIDAZIONE_CONVENZIONE. Multipart: part \&#39;convenzione\&#39; (PDF firmato, max 10 MB). Solo per le domande in modalita\&#39; BANDO o DOMANDA. 422 se lo stato o la modalita\&#39; non lo ammettono o il PDF non e\&#39; valido; 404 cross-esercente.
     * @endpoint post /api/v1/esercente/pratiche/{id_pratica}/convenzione-firmata
* @param requestParameters
     */
    caricaConvenzioneFirmataEsercente(requestParameters: CaricaConvenzioneFirmataEsercenteRequestParams, extraHttpRequestParams?: any): Observable<{}>;

    /**
     * Scarica un proprio allegato della domanda.
     * Download di un file caricato dall\&#39;esercente (origine&#x3D;ESERCENTE: allegato del modulo o convenzione firmata), owner-scoped. 404 privacy-preserving se la domanda non è propria o l\&#39;allegato non appartiene alla domanda / non è dell\&#39;esercente.
     * @endpoint get /api/v1/esercente/pratiche/{id_pratica}/allegati/{id_allegato}/download
* @param requestParameters
     */
    downloadAllegatoPraticaEsercente(requestParameters: DownloadAllegatoPraticaEsercenteRequestParams, extraHttpRequestParams?: any): Observable<string>;

    /**
     * Scarica il file della convenzione del bando per la propria domanda.
     * Solo per le domande in modalita\&#39; BANDO. Se la convenzione del bando e\&#39; un link, il link e\&#39; in convenzione_bando_link del dettaglio. 404 se la domanda non e\&#39; BANDO, se il bando non ha un file o se la domanda e\&#39; di un altro esercente.
     * @endpoint get /api/v1/esercente/pratiche/{id_pratica}/convenzione-bando/download
* @param requestParameters
     */
    downloadConvenzioneBandoEsercente(requestParameters: DownloadConvenzioneBandoEsercenteRequestParams, extraHttpRequestParams?: any): Observable<string>;

    /**
     * Scarica la convenzione controfirmata.
     * Download del PDF controfirmato dall\&#39;operatore. 404 se assente / cross-esercente.
     * @endpoint get /api/v1/esercente/pratiche/{id_pratica}/convenzione-controfirmata/download
* @param requestParameters
     */
    downloadConvenzioneControfirmataEsercente(requestParameters: DownloadConvenzioneControfirmataEsercenteRequestParams, extraHttpRequestParams?: any): Observable<string>;

    /**
     * Scarica il documento da firmare caricato dal comune per la propria domanda.
     * Modalita\&#39; DOMANDA. 404 se assente / cross-esercente.
     * @endpoint get /api/v1/esercente/pratiche/{id_pratica}/convenzione-da-firmare/download
* @param requestParameters
     */
    downloadConvenzioneDaFirmareEsercente(requestParameters: DownloadConvenzioneDaFirmareEsercenteRequestParams, extraHttpRequestParams?: any): Observable<string>;

    /**
     * Scarica la convenzione firmata.
     * Download del PDF caricato dall\&#39;esercente. 404 se assente / cross-esercente.
     * @endpoint get /api/v1/esercente/pratiche/{id_pratica}/convenzione-firmata/download
* @param requestParameters
     */
    downloadConvenzioneFirmataEsercente(requestParameters: DownloadConvenzioneFirmataEsercenteRequestParams, extraHttpRequestParams?: any): Observable<string>;

    /**
     * Scarica il PDF della propria domanda.
     * PDF generato al submit (o rigenerato dal comune). 404 se assente / cross-esercente.
     * @endpoint get /api/v1/esercente/pratiche/{id_pratica}/pdf-originale/download
* @param requestParameters
     */
    downloadPdfOriginalePraticaEsercente(requestParameters: DownloadPdfOriginalePraticaEsercenteRequestParams, extraHttpRequestParams?: any): Observable<string>;

    /**
     * Dettaglio di una propria domanda.
     * 404 privacy-preserving se la domanda è di un altro esercente.
     * @endpoint get /api/v1/esercente/pratiche/{id_pratica}
* @param requestParameters
     */
    getPraticaEsercente(requestParameters: GetPraticaEsercenteRequestParams, extraHttpRequestParams?: any): Observable<PraticaEsercenteDetailDTO>;

    /**
     * Elenca le proprie domande (filtrabile).
     * Page delle sole domande del proprio ProfiloEsercente, sempre ordinate per timestamp_richiesta DESC (sort fisso applicato dal service: il ?sort query param e\&#39; ignorato). Filtri opzionali via query string: comune_slug (comune del bando), stato (macro-stato StatoPraticaEsercente: IN_VALUTAZIONE/IN_CONVENZIONE/ABILITATA/DISABILITATA/RIFIUTATA/RITIRATA), tipo_pratica_id (singolo bando), q (ricerca case-insensitive sul codice_pratica). Tutti additivi e nullable: la chiamata senza param resta invariata.
     * @endpoint get /api/v1/esercente/pratiche
* @param requestParameters
     */
    listPraticheEsercente(requestParameters: ListPraticheEsercenteRequestParams, extraHttpRequestParams?: any): Observable<PagedModelPraticaEsercenteSummaryDTO>;

    /**
     * Ritira una domanda sottomessa.
     * SOTTOMESSA → RITIRATA (self-service). 422 se lo stato non ammette il ritiro; 404 privacy-preserving cross-esercente.
     * @endpoint post /api/v1/esercente/pratiche/{id_pratica}/ritira
* @param requestParameters
     */
    ritiraPraticaEsercente(requestParameters: RitiraPraticaEsercenteRequestParams, extraHttpRequestParams?: any): Observable<{}>;

    /**
     * Sottometti una domanda a un bando.
     * Multipart: part \&#39;pratica\&#39; (JSON con tipo_pratica_id, form_data chiave-driven, negozi_ids) + N part \&#39;allegato_&lt;chiave&gt;\&#39;. Crea la domanda in SOTTOMESSA. 404 bando non partecipabile/no-profilo; 409 dedupe/stato; 422 vincoli/consensi/no-negozi.
     * @endpoint post /api/v1/esercente/pratiche
* @param requestParameters
     */
    submitPraticaEsercente(requestParameters: SubmitPraticaEsercenteRequestParams, extraHttpRequestParams?: any): Observable<PraticaEsercenteSubmitResponseDTO>;

}
